import moment from "moment";

const defaultDropdown = (val: any) => ({
    option: {
        label: val.label,
        id: val.id,
    },
    type: "select",
    value: [{
        label: val.label,
        id: val.id,
    }]
})

const formDefaults = {
    publicationNumber: '',
    applicationNumber: '',
    ipcSymbol: '',
    publicationDate: {
        option: {
            label: 'Between',
            id: 'between',
        },
        type: "select",
        value: [{
            label: 'Between',
            id: 'between',
        }]
    },
    allKinds: true,
    checkbox_A1: true,
    checkbox_A2: true,
    checkbox_A3: true,
    checkbox_A8: true,
    checkbox_A9: true,
    checkbox_B1: true,
    checkbox_B2: true,
    checkbox_B3: true,
    checkbox_B8: true,
    checkbox_B9: true,
}

const getWeeksCount = (selectedYear: number) => {
    const currentWeek = moment().isoWeek();
    const showWeek = moment().day() >= 3 ? currentWeek : currentWeek - 1;
    
    return (selectedYear === moment().year() ? showWeek : moment(`${selectedYear}`).isoWeeksInYear());
}

export { formDefaults, defaultDropdown, getWeeksCount };